import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getGarmentRemarks, getLocalAppServices, getLocalGarmentRemarksPriority, getLocalServiceUnit, getStoreLocalData, getUserData, setGarmentRemarks, setLocalAppServices, setLocalGarmentRemarksPriority, setLocalServiceUnit } from "../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import {
  getStoreGarmentRemarks,
  getStoreGarmentRemarksPriority,
  postGarmentCategoryV3,
} from "../../services/GarmentCategory/GarmentCategory";
import { getCartDetail, getCartDetailV2 } from "../../services/Cart/cartDetail";
import { packageInfoByPriceId } from "../../services/PackageBooking/PackageInfoByPriceId";
import { ProgressSpinner } from "primereact/progressspinner";

import { Sidebar } from "primereact/sidebar";
import "./sideBar.css";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import BottomSheetView from "./BottomSheetView";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import {
  postBrandPriceListConfigData,
  postPriceListConfig,
  searchGarmentFromList,
} from "../../services/getPriceCode";
import { getBrandAppService } from "../../services/BrandAppServices";
import { getServiceUnit } from "../../services/serviceUnit";
import { errorMessage, successMessage } from "../../utils/alertMessage";

const { innerWidth: width, innerHeight: height } = window;

const GeneralBookingSelection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { priceId, BookingType, storeCustomerId, bookingOrderId, B2BModel } =
    location.state || {}; // Fallback to prevent undefined errors

  const {
    storeData,
    userProfileData,
    brandProfileData,
    garmentCategoryServiceIconsResData,
  } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const storeId = storeData.id;

  let brandId = brandProfileData.id;
  const garmentMaxProcessCount = brandProfileData.garmentMaxProcessCount;
  const storeUserId = userProfileData.id;
  const offerPriceEnabled = storeData.offerPriceEnabled;
  const enabledAutoSelectAppService = storeData.enabledAutoSelectAppService;
  const enabledPreDefinedRemark = storeData.enabledPreDefinedRemark;
  const enabledAddGarmentServicePrice = storeData.enabledAddGarmentServicePrice;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;
  const enabledAutoPackageCalculate = storeData.enabledAutoPackageCalculate;

  const [visibleBottom, setVisibleBottom] = useState(false);

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedGarment, setSelectedGarment] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const selectedPriceId = priceId;
  const postGarmentCategoryData = {
    priceIds: [selectedPriceId],
    priceType: "",
  };

  const flatListRef = useRef(null);

  const [categoryData, setCategoryData] = useState([]);
  const [packageData, setPackageData] = useState({});
  const [packageImage, setPackageImage] = useState({});
  const [selectedCategoryData, setSelectedCategoryData] = useState();

  const [originalData, setOriginalData] = useState({}); // New state for original data
  const [refreshing, setRefreshing] = useState(false);
  const [storeGarmentRemarksData, setStoreGarmentRemarksData] = useState("");
  const [storeGarmentRemarksPriorityData, setStoreGarmentRemarksPriorityData] = useState([])

  const [cartItemDetails, setCartItemDetails] = useState([]);
  const [totalPriceSum, setTotalPriceSum] = useState(null);

  const [showGarmentAddScreen, setShowGarmentAddScreen] = useState(false);
  const [appServiceSelection, setAppServiceSelection] = useState(false);
  const [serviceUnitSelection, setServiceUnitSelection] = useState(false);
  const [appServiceList, setAppServiceList] = useState([]);
  const [serviceUnitList, setServiceUnitList] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchedGarment, setSearchedGarment] = useState([]);
  const [addGarmentButtonDisabled, setAddGarmentButtonDisabled] = useState(false)

  const [formData, setFormData] = useState({});
  const [formItemId, setFormItemId] = useState([]);

  const filterParams = {
    category: "",
    searchText: "",
  };

  // Function to filter the data based on the search term
  const fetchGarmentCategoryList = async () => {
    setLoading(true);
    try {
      const response = await postGarmentCategoryV3(
        storeId,
        postGarmentCategoryData
      );
      if (!response.data.error) {
        // Manually sort the categories based on the desired order
        const orderedCategories = ["MEN", "WOMEN", "KID", "OTHER"];

        const sortedCategoryList = response.data.categoryList.sort(
          (a, b) =>
            (orderedCategories.includes(a.name)
              ? orderedCategories.indexOf(a.name)
              : Infinity) -
            (orderedCategories.includes(b.name)
              ? orderedCategories.indexOf(b.name)
              : Infinity) || a.name.localeCompare(b.name) // Sort remaining categories alphabetically
        );

        setCategoryData(
          sortedCategoryList.map((item, index) => ({
            ...item,
            isSelect: index === 0, // Select the first category by default
          }))
        );

        filterParams.category = sortedCategoryList[0]?.name;
        setOriginalData(response.data.categoryGarmentMap);

        const sortedInitialData = [
          ...(response.data.categoryGarmentMap[sortedCategoryList[0]?.name] ||
            []),
        ].sort((a, b) => a.garment.name.localeCompare(b.garment.name));

        setFilteredData(sortedInitialData);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchCartDetail = async () => {
    try {
      const response = await getCartDetailV2(storeCustomerId, storeId);
      if (!response.data.error) {
        const cartRes = response.data;
        setCartData(cartRes);
        setCartItemDetails(cartRes);
        setTotalPriceSum(
          cartRes.reduce((total, item) => total + item.garmentTotalPrice, 0)
        );
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchPackageInfoByPriceId = () => {
    packageInfoByPriceId(storeId, selectedPriceId)
      .then((response) => {
        if (!response.data.error) {
          setPackageData(response.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchGetServiceUnit = async () => {
    try {
      const response = await getServiceUnit()
      if (!response.data.error) {
        const res = response.data
          .filter(
            (item) => item === "SqFt" || item === "Mtr" || item === "Qty"
          ) // Keep only desired items
          .map((item) => ({
            label: item === "Qty" ? "Piece" : item, // Rename "Qty" to "Piece"
            value: item === "Qty" ? "Qty" : item, // Keep "Qty" as value, otherwise use item as both label and value
          }));
        setServiceUnitList(res);
        setLocalServiceUnit(res);
      }
    } catch (err) {
      console.error("Error:", err);
    }

  };

  const fetchServiceUnit = async () => {
    const { serviceUnit } = getLocalServiceUnit();
    if (serviceUnit && Object.keys(serviceUnit).length > 0) {
      setServiceUnitList(serviceUnit);
    } else {
      await fetchGetServiceUnit();
    }
  };

  const fetchAppService = async () => {
    try {
      const response = await getBrandAppService(brandId);
      if (!response.data.error) {
        const appServiceData = response.data.filter(
          (service) => service.status === true
        );
        const res = appServiceData.map((service) => ({
          label: service.appService.name,
          value: service.appService.name,
        }));
        setAppServiceList(res);
        setLocalAppServices(res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalAppServices = async () => {
    const { appServices } = getLocalAppServices();
    if (appServices && Object.keys(appServices).length > 0) {
      setAppServiceList(appServices);
    } else {
      await fetchAppService();
    }
  };

  const fetchStoreGarmentRemarksPriority = async () => {
    try {
      const response = await getStoreGarmentRemarksPriority(
        brandId
      );
      if (!response.data.error) {
        setStoreGarmentRemarksPriorityData(response.data);

        // Save API response to localStorage
        setLocalGarmentRemarksPriority(response.data);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalGarmentRemarksPriority = async () => {
    const { garmentRemarksPriority } = getLocalGarmentRemarksPriority();
    if (
      garmentRemarksPriority &&
      Object.keys(garmentRemarksPriority).length > 0
    ) {
      setStoreGarmentRemarksPriorityData(garmentRemarksPriority);
    } else {
      await fetchStoreGarmentRemarksPriority();
    }
  };

  const fetchStoreGarmentRemarks = async () => {
    try {
      const response = await getStoreGarmentRemarks(brandId, storeId);
      if (!response.data.error) {
        setStoreGarmentRemarksData(response.data);

        // Save API response to localStorage
        setGarmentRemarks(response.data);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchGarmentRemarks = async () => {
    const { garmentRemarks } = getGarmentRemarks();
    if (garmentRemarks && Object.keys(garmentRemarks).length > 0) {
      setStoreGarmentRemarksData(garmentRemarks);
    } else {
      await fetchStoreGarmentRemarks();
    }
  };


  useEffect(() => {
    if (BookingType === "PackageBooking") {
      fetchPackageInfoByPriceId();
    }
    fetchGarmentCategoryList();
    fetchGarmentRemarks();
    fetchServiceUnit();
    fetchLocalAppServices();
    fetchCartDetail();
    fetchLocalGarmentRemarksPriority();

  }, [priceId]);

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    if (BookingType === "PackageBooking") {
      fetchPackageInfoByPriceId();
    }
    fetchGarmentCategoryList();
    fetchCartDetail();
    setTimeout(() => {
      setRefreshing(false);
    }, 2000);
  }, []);

  // State for the cart data
  const [cartData, setCartData] = useState([]);
  // Function to add the garment to the cart
  const handleAddToCart = (garment) => {
    setCartData((prevCartData) => [...prevCartData, garment]);
    fetchCartDetail();
  };

  const onSelectCategory = (categoryName) => {
    // Check if the category is already selected
    setLoading(true);
    const newData = categoryData.map((item) => ({
      ...item,
      isSelect: item.name === categoryName ? true : false,
    }));
    setCategoryData(newData);
    const isCategorySelected =
      newData.find((item) => item.name === categoryName)?.isSelect || false;

    if (isCategorySelected) {
      setSelectedCategoryData(newData.find((item) => item.isSelect)?.name);
      filterParams.category = categoryName;
      filterParams.searchText = searchTerm ? searchTerm : "";
      const initialData = filterData(
        originalData[filterParams.category],
        filterParams
      );
      const filtered = [...initialData].sort((a, b) =>
        a.garment.name.toLowerCase().localeCompare(b.garment.name.toLowerCase())
      );
      setFilteredData(filtered);
      setLoading(false);
      flatListRef?.current?.scrollToOffset({ offset: 0, animated: true });
      setFormItemId([]);
      setFormData({});
      setAppServiceSelection("");
      setServiceUnitSelection("");
    }
  };

  const filterData = (data, filterParams) => {
    if (filterParams.searchText !== "") {
      return data.filter((item) =>
        item.garment.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      return data.filter((item) => item);
    }
  };

  const navigateToCartPage = () => {
    navigate("/CartPage", {
      state: {
        BookingType: BookingType,
        storeCustomerId: storeCustomerId,
      },
    });
  };

  const toggleBottomNavigationView = (item, logo) => {
    item.garment.logo = logo;
    setSelectedGarment(item);
    //Toggling the visibility state of the bottom sheet
    setVisible(!visible);
    // setVisibleBottom(true);
  };

  const toggleBottomNavigationViewClosed = () => {
    setVisible(false);
  };

  // const handleInputChange = (event, garmentName, itemId) => {
  //   const value = event.target.value;

  //   // Update form data
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [garmentName]: value,
  //   }));

  //   // Add itemId only if it's not already included
  //   setFormItemId((prevItemIds) => {
  //     if (!prevItemIds.includes(itemId)) {
  //       return [...prevItemIds, itemId];
  //     }
  //     return prevItemIds;
  //   });
  // };

  // const handleInputChange = (event, garmentName, itemId) => {
  //   const value = event.target.value;

  //   if (value === "") {
  //     // Remove from formData
  //     setFormData((prevFormData) => {
  //       const newFormData = { ...prevFormData };
  //       delete newFormData[garmentName];
  //       return newFormData;
  //     });

  //     // Remove from formItemId
  //     setFormItemId((prevItemIds) => prevItemIds.filter((id) => id !== itemId));
  //   } else {
  //     // Add/update in formData
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       [garmentName]: value,
  //     }));

  //     // Add itemId only if it's not already included
  //     setFormItemId((prevItemIds) => {
  //       if (!prevItemIds.includes(itemId)) {
  //         return [...prevItemIds, itemId];
  //       }
  //       return prevItemIds;
  //     });
  //   }
  // };

  const handleInputChange = (event, garmentName, itemId) => {
    const value = event.target.value;

    // Allow clearing the input
    if (value === "") {
      setFormData((prevFormData) => {
        const newFormData = { ...prevFormData };
        delete newFormData[garmentName];
        return newFormData;
      });

      setFormItemId((prevItemIds) => prevItemIds.filter((id) => id !== itemId));
    } else if (Number(value) > 0) {
      // Only allow values greater than 0
      setFormData((prevFormData) => ({
        ...prevFormData,
        [garmentName]: value,
      }));

      setFormItemId((prevItemIds) => {
        if (!prevItemIds.includes(itemId)) {
          return [...prevItemIds, itemId];
        }
        return prevItemIds;
      });
    }
    // Do nothing for zero or negative input
  };


  const handleSelectionChange = (event, garmentName, itemId) => {
    const value = event.target.checked;

    if (value === "") {
      // Remove from formData
      setFormData((prevFormData) => {
        const newFormData = { ...prevFormData };
        delete newFormData[garmentName];
        return newFormData;
      });

      // Remove from formItemId
      setFormItemId((prevItemIds) => prevItemIds.filter((id) => id !== itemId));
    } else {
      // Add/update in formData
      setFormData((prevFormData) => ({
        ...prevFormData,
        [garmentName]: value,
      }));

      // Add itemId only if it's not already included
      setFormItemId((prevItemIds) => {
        if (!prevItemIds.includes(itemId)) {
          return [...prevItemIds, itemId];
        }
        return prevItemIds;
      });
    }
  };

  useEffect(() => {
    if (searchTerm.length > 2) {
      const data = {
        garmentName: searchTerm,
        categoryNameIn: categoryData
          .filter((item) => item.isSelect === true)
          .map((itemValue) => itemValue.name),
      };

      searchGarmentFromList(data)
        .then((response) => {
          if (!response.data.error) {
            const responseList = response.data;

            // Assuming each garment has a unique `id` (you can change this to `garmentId` or `name` if needed)
            const filteredGarments = responseList.filter(
              (item) =>
                !filteredData.some(
                  (filteredItem) => filteredItem.id === item.id
                )
            );

            setSearchedGarment(filteredGarments);
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    } else {
      setSearchedGarment([]);
      setFormItemId([]);
      setFormData({});
      setAppServiceSelection("");
      setServiceUnitSelection("");
    }
  }, [searchTerm, categoryData]);

  const handleAddGarmentApi = () => {
    const data = {
      appServiceList: [appServiceSelection],
      serviceUnit: serviceUnitSelection,
      priceId: priceId,
      garmentCategoryIdIn: formItemId,
    };

    setAddGarmentButtonDisabled(true)

    postBrandPriceListConfigData(brandId, data)
      .then((response) => {
        if (!response.data.error && response.data.success !== false) {
          const { priceListDTO } = response.data;

          // Prepare payload for second API
          const formattedList = Object.entries(priceListDTO).map(
            ([garmentName, categoryObj]) => {
              const category = Object.keys(categoryObj)[0]; // "OTHER"
              const brandAppServiceName = Object.keys(categoryObj[category])[0]; // "WASH"
              const item = categoryObj[category][brandAppServiceName];

              return {
                id: item.id,
                garmentName: item.garmentName,
                category: item.category,
                brandAppServiceName: item.brandAppServiceName,
                garmentCategory: item.garmentCategory,
                brandAppService: item.brandAppService,
                serviceUnit: item.serviceUnit,
                amount: formData[item.garmentName] || 0, // fetch value from formData
                minAmount: item.minAmount,
                status: true,
              };
            }
          );

          const secondPayload = {
            priceListDTO: formattedList,
            serviceUnit: serviceUnitSelection,
            appServiceList: [appServiceSelection],
            priceId: priceId,
          };

          // 🔁 Call second API here
          postPriceListConfig(brandId, secondPayload)
            .then((response) => {
              if (!response.data.error) {
                if (response.data.success === false) {
                  // setSubmitButtonPressed(false);
                  errorMessage(response.data.message);
                  setAddGarmentButtonDisabled(false)
                } else {
                  successMessage(response.data.message);
                  // if (BookingType === "PackageBooking") {
                  //   fetchPackageInfoByPriceId();
                  // }
                  // fetchGarmentCategoryList();
                  // fetchStoreGarmentRemarks();
                  // fetchCartDetail();
                  // fetchAppService();
                  // fetchGetServiceUnit();
                  // setFormItemId([]);
                  // setFormData({});
                  // setAppServiceSelection("")
                  // setServiceUnitSelection("")
                  setAddGarmentButtonDisabled(false)
                  window.location.reload();
                }
              }
            })
            .catch((err) => {
              console.error("second API Error", err);
            });
        }
      })
      .catch((err) => {
        console.error("First API Error", err);
      });
  };

  const handlePackageAddGarmentApi = () => {
    const data = {
      serviceUnit: packageData.serviceUnit,
      appServiceList: [packageData.appService],
      priceId: priceId,
      garmentCategoryIdIn: formItemId,
    };

    postBrandPriceListConfigData(brandId, data)
      .then((response) => {
        if (!response.data.error && response.data.success !== false) {
          const { priceListDTO } = response.data;

          // Prepare payload for second API
          const formattedList = Object.entries(priceListDTO).map(
            ([garmentName, categoryObj]) => {
              const category = Object.keys(categoryObj)[0]; // "OTHER"
              const brandAppServiceName = Object.keys(categoryObj[category])[0]; // "WASH"
              const item = categoryObj[category][brandAppServiceName];

              return {
                id: item.id,
                garmentName: item.garmentName,
                category: item.category,
                brandAppServiceName: item.brandAppServiceName,
                garmentCategory: item.garmentCategory,
                brandAppService: item.brandAppService,
                serviceUnit: item.serviceUnit,
                amount: item.amount, // fetch value from formData
                minAmount: item.minAmount,
                status: true,
              };
            }
          );

          const secondPayload = {
            priceListDTO: formattedList,
            serviceUnit: packageData.serviceUnit,
            appServiceList: [packageData.appService],
            priceId: priceId,
          };

          // 🔁 Call second API here
          postPriceListConfig(brandId, secondPayload)
            .then((response) => {
              if (!response.data.error) {
                if (response.data.success === false) {
                  // setSubmitButtonPressed(false);
                  errorMessage(response.data.message);
                  setAddGarmentButtonDisabled(false)
                } else {
                  successMessage(response.data.message);
                  // if (BookingType === "PackageBooking") {
                  //   fetchPackageInfoByPriceId();
                  // }
                  // fetchGarmentCategoryList();
                  // fetchStoreGarmentRemarks();
                  // fetchCartDetail();
                  // fetchAppService();
                  // fetchGetServiceUnit();
                  // setFormItemId([]);
                  // setFormData({});
                  // setAppServiceSelection("")
                  // setServiceUnitSelection("")
                  setAddGarmentButtonDisabled(false)
                  window.location.reload();
                }
              }
            })
            .catch((err) => {
              console.error("second API Error", err);
            });
        }
      })
      .catch((err) => {
        console.error("First API Error", err);
      });
  };

  useEffect(() => {
    // Filter the data based on the search term
    setLoading(true);
    if (Object.keys(originalData).length > 0) {
      if (selectedCategoryData !== undefined) {
        filterParams.category = selectedCategoryData;
      } else {
        filterParams.category = categoryData[0]?.name;
      }
      filterParams.searchText = searchTerm ? searchTerm : "";

      const initialData = filterData(
        originalData[filterParams.category],
        filterParams
      );
      const filtered = [...initialData].sort((a, b) =>
        a.garment.name.toLowerCase().localeCompare(b.garment.name.toLowerCase())
      );

      setFilteredData(filtered);
      setLoading(false);
    }
  }, [searchTerm, originalData]);

  const transformedCartData = cartItemDetails.map((item, index) => ({
    id: index + 1,
    garmentName: item.garmentName,
    categoryName: item.categoryName,
    garmentCount: item.totalItemGarmentCount,
    price: item.garmentTotalPrice,
    cartGarmentList: item.cartGarmentList.map((cartGarmentItem) => ({
      itemId: item.id,
      addOn:
        cartGarmentItem.addOn.length > 0
          ? cartGarmentItem.addOn.map((addOnItem) => addOnItem)
          : null,
      bookingType: cartGarmentItem.bookingType,
    })),
  }));

  const totalGarmentCount = transformedCartData.reduce((sum, item) => {
    return sum + (item.garmentCount || 0); // add garmentQrCount or 0 if undefined
  }, 0);

  const renderCartCardItem = () => {
    return transformedCartData?.map((item, index) => {
      return (
        <div>
          <div
            className="flex-1 px-3 py-1 border-bottom-1 "
            style={{
              borderBottomColor: "#fff",
            }}
          >
            <div className="flex-row">
              <div className="flex-1">
                <div className="flex-1 flex ml-2" style={{ flexWrap: "wrap" }}>
                  <p
                    className=" text-sm font-medium capitalize ml-2"
                    style={{ color: "#103976" }}
                  >
                    {item.garmentName.replace(/_/g, " ")}
                  </p>
                  {item.cartGarmentList.map((cartGarmentItem) => (
                    <React.Fragment key={cartGarmentItem.id}>
                      {cartGarmentItem.addOn?.map((service) => (
                        <p
                          className=" text-sm font-normal ml-2"
                          key={service.id}
                          style={{ flexWrap: "wrap", color: "#061833" }}
                        >
                          {service.serviceName} | {service.serviceUnit}
                          {cartGarmentItem.bookingType === "GeneralBooking" && (
                            <React.Fragment>
                              {" | "}
                              {service.serviceUnit === "Qty"
                                ? service.count
                                : parseFloat(
                                  service.count + service.countGram
                                ).toFixed(2)}{" "}
                              | {storeLocalData?.currencySymbol} {Number(service.totalPrice?.toFixed(enabledAmountRoundOff))}
                            </React.Fragment>
                          )}
                          {cartGarmentItem.bookingType === "PackageBooking" && service.serviceUnit === "Kg" && enabledAutoPackageCalculate && (
                            <React.Fragment>
                              {" | "}
                              {parseFloat(
                                service.count + service.countGram
                              ).toFixed(2)}{" "}
                            </React.Fragment>
                          )}
                        </p>
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  const renderCardItem = () => {
    return filteredData?.map((item, index) => (
      <div
        className="flex justify-content-center"
        style={{
          width: "25%",
          height: "50%",
        }}
      >
        <div className="mx-4 my-2 flex align-self-center">
          <div
            onClick={() =>
              toggleBottomNavigationView(
                item,
                garmentCategoryServiceIconsResData?.iconMap[
                item?.garment?.imageId
                ]
              )
            }
            className="cursor-pointer"
          >
            <div className="flex justify-content-center">
              <img
                // src={
                //   item.garment.logo !== null
                //     ? `data:image/jpeg;base64,${item.garment.logo}`
                //     : "Laundry_app_icons/Tshirt.png"
                // }
                src={
                  garmentCategoryServiceIconsResData?.iconMap[
                    item?.garment?.imageId
                  ]
                    ? `data:image/jpeg;base64,${garmentCategoryServiceIconsResData?.iconMap[
                    item?.garment?.imageId
                    ]
                    }`
                    : "Laundry_app_icons/Tshirt.png"
                }
                resizeMode="cover"
                style={{
                  alignSelf: "center", // to center an image
                  width: height < 600 ? 50 : 60,
                  height: height < 600 ? 50 : 60,
                }}
                alt="garmentIcon"
              />
            </div>
            <p className="my-2 text-base font-normal text-center capitalize">
              {item.garment.name.replace(/_/g, " ")}
            </p>
          </div>
        </div>
      </div>
    ));
  };

  const renderSearchedGarmentCardItem = () => {
    return searchedGarment?.map((item, index) => (
      <div
        className="flex justify-content-center border-round-xl shadow-2 mx-1 my-2"
        style={{
          width: "30%",
          height: "50%",
          backgroundColor: "#fff",
        }}
      >
        <div>
          <p className="my-2 text-base font-normal text-center capitalize">
            {item.garment.name.replace(/_/g, " ")}
          </p>
          {BookingType === "PackageBooking" ? (
            <div className="mb-2 flex justify-content-center">
              <p className="mr-2">Select</p>
              <input
                type="checkbox"
                style={{ width: 20, height: 20 }}
                id={`${item.garment.name}`}
                name={`${item.garment.name}`}
                checked={
                  formData[`${item.garment.name}`] !== undefined
                    ? formData[`${item.garment.name}`]
                    : ""
                }
                onChange={(e) =>
                  handleSelectionChange(e, item.garment.name, item.id)
                }
              />
            </div>
          ) : (
            <div className="mb-2 flex justify-content-center">
              <p className="mr-2">Price</p>
              <InputText
                type="number"
                min={1} // restricts values in UI
                style={{ width: 50, height: 10 }}
                id={`${item.garment.name}`}
                name={`${item.garment.name}`}
                value={
                  formData[`${item.garment.name}`] !== undefined
                    ? formData[`${item.garment.name}`]
                    : ""
                }
                onChange={(e) =>
                  handleInputChange(e, item.garment.name, item.id)
                }
                onKeyDown={(e) => {
                  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          )}
        </div>
      </div>
    ));
  };

  const renderCategoryCardItem = () => {
    return categoryData?.map((item, index) => {
      return (
        <div
          className="flex justify-content-center align-self-center"
          style={{
            width: "20%",
            // height: "50%",
          }}
        >
          <div
            onClick={() => onSelectCategory(item.name)}
            className="cursor-pointer"
          >
            <div className="flex justify-content-center">
              <img
                // src={
                //   item.logo !== null
                //     ? `data:image/jpeg;base64,${item.logo}`
                //     : "images/garments2.png"
                // }
                src={
                  garmentCategoryServiceIconsResData?.iconMap[item?.imageId]
                    ? `data:image/jpeg;base64,${garmentCategoryServiceIconsResData?.iconMap[
                    item?.imageId
                    ]
                    }`
                    : "images/garments2.png"
                }
                resizeMode="cover"
                style={{
                  alignSelf: "center", // to center an image
                  width: item.isSelect
                    ? height < 600
                      ? 65
                      : 75
                    : height < 600
                      ? 50
                      : 60,
                  height: item.isSelect
                    ? height < 600
                      ? 65
                      : 75
                    : height < 600
                      ? 50
                      : 60,
                }}
                alt="icon"
              />
            </div>
            <div className="mx-2 align-self-center my-2">
              <p
                className="text-lg font-normal"
                style={{
                  color: item.isSelect ? "#008EFF" : "#75879B",
                  textAlign: "center",
                }}
              >
                {item.name}
              </p>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left cursor-pointer"
                  onClick={() =>
                    bookingOrderId && B2BModel
                      ? navigate("/B2BOrdersGarmentInfo", {
                        state: {
                          bookingOrderId: bookingOrderId,
                          storeCustomerId: storeCustomerId,
                        },
                      })
                      : bookingOrderId ?
                        navigate("/OrdersGarmentInfo", {
                          state: {
                            bookingOrderId: bookingOrderId,
                            storeCustomerId: storeCustomerId,
                          },
                        })
                        : navigate("/BookNewOrder", {
                          state: {
                            storeCustomerId: storeCustomerId,
                          },
                        })
                  }
                  style={{ fontSize: "27px", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Book New Order
              </p>
            </div>
          </div>

          {!bookingOrderId ? (
            <div
              className="flex justify-content-center align-items-center mr-2 cursor-pointer"
              onClick={() => cartData.length > 0 && navigateToCartPage()}
            // disabled={cartData.length <= 0 && true}
            >
              <i
                className="pi pi-shopping-cart"
                style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
              ></i>

              {cartData.length > 0 && (
                <div
                  style={{
                    position: "relative",
                    backgroundColor: "red",
                    height: 25,
                    width: 25,
                    borderRadius: 50,
                    top: -7,
                    right: 5,
                  }}
                >
                  <p className="text-white text-lg text-center font-bold capitalize">
                    {cartData.length}
                  </p>
                </div>
              )}
            </div>
          ) : (
            <div>
              <i
                className="pi pi-shopping-cart
"
                style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
              ></i>
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          backgroundColor: "mintcream",
          flex: 1,
          height: "100%",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 1 }}>
            {BookingType === "PackageBooking" && (
              <div>
                <div
                  className="flex-1  surface-0"
                  style={{ "--surface-0": "#EAEFF5" }}
                >
                  <div className="flex justify-content-between mx-4">
                    <div className="py-1">
                      <p className=" text-2xl  font-bold ">
                        Your Selected Package
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="mx-4 my-2 flex flex-row">
                    <div className="flex-1">
                      <div className="flex justify-content-center">
                        <img
                          src={
                            "/Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif"
                          }
                          resizeMode="cover"
                          style={{
                            alignSelf: "center", // to center an image
                            width: height < 600 ? 70 : 80,
                            height: height < 600 ? 70 : 80,
                          }}
                        />
                      </div>
                      <div className="flex justify-content-center my-2">
                        <p className="text-lg font-normal">
                          {packageData.name}
                        </p>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div>
                        <div
                          className="cursor-pointer"
                          onClick={() =>
                            navigate("/BookNewOrder", {
                              state: {
                                storeCustomerId: storeCustomerId,
                                packageBookingModal: true,
                              },
                            })
                          }
                        >
                          <div>
                            <div className="flex justify-content-center">
                              <img
                                src={"Icons/return.png"}
                                resizeMode="cover"
                                style={{
                                  alignSelf: "center", // to center an image
                                  width: height < 600 ? 70 : 80,
                                  height: height < 600 ? 70 : 80,
                                }}
                              />
                            </div>
                            <div className="flex justify-content-center my-2">
                              <p className="text-lg font-normal">
                                Change Your Package
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 1 }}></div>
              </div>
            )}
            <div
              className="flex-1  surface-0"
              style={{ "--surface-0": "#EAEFF5" }}
            >
              <div className="flex justify-content-between mx-4">
                <div className="py-1">
                  <p className=" text-2xl  font-bold ">Category</p>
                </div>
              </div>
            </div>
            <div
              className="mx-4 my-2 "
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexWrap: "wrap",
              }}
            >
              {categoryData.length > 0 ? (
                renderCategoryCardItem()
              ) : (
                <div className="mx-4 my-2 flex flex-row" style={{ flex: 1 }}>
                  <ProgressSpinner
                    style={{ width: "70px", height: "70px" }}
                    strokeWidth="4"
                    fill="var(--surface-ground)"
                    animationDuration="2s"
                  />
                </div>
              )}
            </div>
            {transformedCartData.length !== 0 && (
              <div
                className="flex flex-1"
                style={{ position: "relative", bottom: 0 }}
              >
                <div
                  className="flex-1 surface-0"
                  style={{
                    width: width / 2,
                    position: "fixed",
                    bottom: "0",
                    "--surface-0": "#ebf2fc",
                    borderTopLeftRadius: 25,
                    borderTopRightRadius: 25,
                  }}
                >
                  <div
                    className="flex-1 px-3 py-1 border-bottom-1 "
                    style={{
                      backgroundColor: "#1752AA",
                      borderBottomColor: "#fff",
                      borderTopLeftRadius: 25,
                      borderTopRightRadius: 25,
                    }}
                  >
                    <p className="text-2xl font-bold" style={{ color: "#fff" }}>
                      My Cart
                    </p>
                  </div>
                  <div
                    className="flex-1 custom-scroll"
                    style={{
                      height: 130,
                      overflowY: "scroll",
                      scrollbarWidth: "none", // Firefox
                      msOverflowStyle: "none", // IE 10+
                    }}
                  >
                    <div style={{ backgroundColor: "#ebf2fc" }}>
                      {renderCartCardItem()}
                    </div>
                  </div>
                  <div
                    className="flex flex-row px-3 py-1"
                    style={{ backgroundColor: "#1752AA" }}
                  >
                    <div className="flex flex-row">
                      <p className=" text-lg font-medium text-white capitalize mx-1">
                        Total Garment:{" "}
                      </p>
                      <p className=" text-lg font-medium text-white capitalize mx-1">
                        {totalGarmentCount}
                      </p>
                    </div>
                    <div className="flex flex-row">
                      <p className=" text-lg font-medium text-white capitalize mx-1">
                        Total Amount:{" "}
                      </p>
                      <p className=" text-lg font-medium text-white capitalize mx-1">
                        {storeLocalData?.currencySymbol} {Number(totalPriceSum.toFixed(enabledAmountRoundOff))}
                      </p>
                    </div>
                  </div>
                </div>

                <style>
                  {`
                  .custom-scroll::-webkit-scrollbar {
                    display: none;
                  }
                `}
                </style>
              </div>
            )}
          </div>
          <div className="flex-1">
            <div
              className="flex-1  surface-0"
              style={{ "--surface-0": "#EAEFF5" }}
            >
              <div className="flex justify-content-between mx-4">
                <div className="py-1">
                  <p className=" text-2xl  font-bold ">Garment</p>
                </div>
              </div>
            </div>
            <div>
              <div>
                <div className="my-3 mx-5 flex flex-1">
                  <IconField iconPosition="left" className="flex flex-1">
                    <InputIcon className="pi pi-search text-lg"> </InputIcon>
                    <InputText
                      placeholder="Search Garment"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="text-lg flex flex-1"
                      style={{ borderRadius: 30 }}
                    />
                  </IconField>
                </div>
              </div>
              <div>
                {loading ? (
                  <div style={{ flex: 1 }}>
                    <div className="text-center">
                      <ProgressSpinner
                        style={{ width: "70px", height: "70px" }}
                        strokeWidth="4"
                        fill="var(--surface-ground)"
                        animationDuration="2s"
                      />
                    </div>
                  </div>
                ) : filteredData.length > 0 ? (
                  <div className="flex flex-wrap">{renderCardItem()}</div>
                ) : (
                  <div style={{ flex: 1 }}>
                    <p className="text-2xl text-center">No Garment Found</p>
                  </div>
                )}

                {enabledAddGarmentServicePrice &&
                  searchedGarment.length > 0 && (
                    <div>
                      <div style={{ flex: 1 }}>
                        <div
                          className={
                            "flex flex-1 justify-content-between mx-2 py-2 cursor-pointer px-2"
                          }
                          style={{
                            backgroundColor: "#1752AA",
                            borderRadius: 10,
                          }}
                          onClick={() =>
                            setShowGarmentAddScreen(!showGarmentAddScreen)
                          }
                        >
                          <div className="flex justify-content-start align-items-center flex-1 ">
                            <p
                              className=" text-lg font-medium capitalize ml-2"
                              style={{ color: "#fff" }}
                            >
                              Add More Garments
                            </p>
                          </div>
                          <div>
                            {!showGarmentAddScreen ? (
                              <i
                                className="pi pi-angle-down"
                                style={{
                                  fontSize: "25px",
                                  cursor: "pointer",
                                  color: "#fff",
                                }}
                              ></i>
                            ) : (
                              <i
                                className="pi pi-angle-up"
                                style={{
                                  fontSize: "25px",
                                  cursor: "pointer",
                                  color: "#fff",
                                }}
                              ></i>
                            )}
                          </div>
                        </div>
                      </div>
                      {showGarmentAddScreen && (
                        <div>
                          <div className="flex flex-wrap mx-3 mt-3">
                            <p
                              className="text-md text-center"
                              style={{ color: "red" }}
                            >
                              * To Add Garment Please Enter Price and Select
                              Your Service and Service Unit.
                            </p>
                          </div>
                          <div className="flex flex-wrap mx-3 mt-3">
                            {renderSearchedGarmentCardItem()}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                {formItemId.length > 0 && showGarmentAddScreen && (
                  <div className="mx-3">
                    {BookingType !== "PackageBooking" && (
                      <div className="my-2">
                        <div
                          className="border-round-xl shadow-2"
                          style={{ backgroundColor: "#fff" }}
                        >
                          <Dropdown
                            value={appServiceSelection}
                            onChange={(e) => setAppServiceSelection(e.value)}
                            options={appServiceList}
                            placeholder="App Services"
                            className="w-full  bg-white-alpha-20 text-xl text-primary-50 garmentDropdown"
                          />
                        </div>

                        <div
                          className="border-round-xl shadow-2 my-2"
                          style={{ backgroundColor: "#fff" }}
                        >
                          <Dropdown
                            value={serviceUnitSelection}
                            onChange={(e) => setServiceUnitSelection(e.value)}
                            options={serviceUnitList}
                            placeholder="Service Unit"
                            className="w-full  bg-white-alpha-20 text-xl text-primary-50 garmentDropdown"
                          />
                        </div>
                      </div>
                    )}
                    <div className="my-2">
                      {appServiceSelection &&
                        serviceUnitSelection &&
                        BookingType !== "PackageBooking" && (
                          <Button
                            label="Add Garment"
                            disabled={addGarmentButtonDisabled}
                            onClick={() => handleAddGarmentApi()}
                            className="w-full text-xl border-round-xl border-none cursor-pointer mr-2"
                          ></Button>
                        )}
                      {BookingType === "PackageBooking" && (
                        <Button
                          label="Add Garment"
                          disabled={addGarmentButtonDisabled}
                          onClick={() => handlePackageAddGarmentApi()}
                          className=" w-full text-xl border-round-xl border-none cursor-pointer mr-2"
                        ></Button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <BottomSheetView
          visible={visible}
          toggleBottomNavigationView={toggleBottomNavigationView}
          toggleBottomNavigationViewClosed={toggleBottomNavigationViewClosed}
          selectedGarment={selectedGarment}
          onAddToCart={handleAddToCart}
          storeId={storeId}
          selectedPriceId={selectedPriceId}
          storeCustomerId={storeCustomerId}
          BookingType={BookingType}
          offerPriceEnabled={offerPriceEnabled}
          enabledAutoSelectAppService={enabledAutoSelectAppService}
          storeUserId={storeUserId}
          brandId={brandId}
          bookingOrderId={bookingOrderId}
          storeGarmentRemarksData={storeGarmentRemarksData}
          enabledPreDefinedRemark={enabledPreDefinedRemark}
          garmentMaxProcessCount={garmentMaxProcessCount}
          garmentServiceIcons={garmentCategoryServiceIconsResData?.iconMap}
          userProfileData={userProfileData}
          storeGarmentRemarksPriorityData={storeGarmentRemarksPriorityData}
          B2BModel={B2BModel}
          enabledAmountRoundOff={enabledAmountRoundOff}
          enabledAutoPackageCalculate={enabledAutoPackageCalculate}
          packageData={packageData}
        />
      </div>
    </div>
  );
};

export default GeneralBookingSelection;
